<template>
  <div class="message">
    <div class="left">
      <div class="section">
        <div class="title">退款信息</div>
        <div class="item">
          <div class="label">退款编号：</div>
          <div class="text">
            {{ info.refundOrderSn }}
          </div>
        </div>
        <div class="item">
          <div class="label">归属订单编号：</div>
          <div class="text">
            {{ info.orderSn }}
          </div>
        </div>
        <div class="item">
          <div class="label">退款申请时间：</div>
          <div class="text">
            {{ info.applyTime }}
          </div>
        </div>
        <div class="item">
          <div class="label">退款类型：</div>
          <div class="text">
            {{ returnType }}
          </div>
        </div>
        <div class="item">
          <div class="label">退款原因：</div>
          <div class="text">
            {{ info.refundReason }}
          </div>
        </div>
        <div class="item">
          <div class="label">是否已开具发票：</div>
          <div class="text">
            {{ invoiceType }}
          </div>
        </div>
      </div>
      <div class="section" v-if="[2].includes(payType)">
        <div class="title">收款账户</div>
        <div class="item">
          <div class="label">收款方：</div>
          <div class="text">
            {{ refundAccountInfo.payee }}
          </div>
        </div>
        <div class="item">
          <div class="label">开户行：</div>
          <div class="text">
            {{ refundAccountInfo.openingBank }}
          </div>
        </div>
        <div class="item">
          <div class="label">银行账号：</div>
          <div class="text">
            {{ refundAccountInfo.bankAccount }}
          </div>
        </div>
        <div class="item">
          <div class="label">银行联行号：</div>
          <div class="text">
            {{ refundAccountInfo.bankUnionNumber }}
          </div>
        </div>
        <div class="item">
          <div class="label">收款账号所属省市：</div>
          <div class="text">
            {{ refundAccountInfo.receivingAccountArea }}
          </div>
        </div>
      </div>
      <div class="section">
        <div class="title">补充描述和凭证</div>
        <div class="item">
          <div class="label">凭证：</div>
          <div class="text">
            <el-image
              v-for="i in info.pictures"
              :key="i"
              style="width: 100px; height: 100px; margin-right: 12px"
              :src="i"
              :preview-src-list="info.pictures"
            ></el-image>
          </div>
        </div>
        <div class="item">
          <div class="label">描述：</div>
          <div class="text">
            {{ info.supplyRefundReason }}
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="退货物流" name="退货物流">
          <logisticsInfo :logistics="logistics"></logisticsInfo>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import logisticsInfo from './logisticsInfo';

export default {
  props: ['info'],
  components: {
    logisticsInfo
  },
  data() {
    return {
      activeName: '退货物流'
    };
  },
  computed: {
    returnType() {
      const { returnType } = this.info;
      if (returnType === 0) {
        return '仅退款';
      }
      if (returnType === 2) {
        return '退货退款';
      }
    },
    invoiceType() {
      const { invoiceType } = this.info;
      if (invoiceType === -1) {
        return '未开具';
      }
      if (invoiceType === 1) {
        return '专用发票';
      }
      if (invoiceType === 2) {
        return '普通发票';
      }
    },
    refundAccountInfo() {
      return this.info.refundAccountInfo;
    },
    logistics() {
      return this.info.logisticsInfo;
    },
    payType() {
      return Number(this.info.payType);
    }
  }
};
</script>
<style lang="scss" scoped>
.message {
  border: 1px solid #dfdfdf;
  display: flex;
  margin-bottom: 12px;
  border-top: 1px solid #1e8dff;
  .left {
    flex: 1;
    padding-bottom: 26px;
    border-right: 1px solid #dfdfdf;
    .section {
      margin-top: 16px;
      padding: 0 24px;
      .title {
        font-weight: 400;
        color: #262626;
        line-height: 20px;
        font-size: 12px;
        margin-bottom: 12px;
      }
      @mixin baseitem {
        display: flex;
        margin-bottom: 12px;
        .label {
          font-size: 12px;
          color: #8c8c8c;
        }
        .text {
          flex: 1;
          flex-wrap: wrap;
          font-size: 12px;
          color: #262626;
          line-height: 18px;
          word-break: break-all;
          img {
            width: 48px;
            height: 48px;
            margin-right: 8px;
          }
        }
      }
      .item {
        @include baseitem;
      }
    }
  }
  .right {
    flex: 1;
    padding-left: 23px;
    padding-top: 16px;
    overflow: scroll;
    max-height: 549px;
  }
}
</style>
